import { render, staticRenderFns } from "./LawSubjectList.vue?vue&type=template&id=6d3e3748&"
import script from "./LawSubjectList.vue?vue&type=script&lang=js&"
export * from "./LawSubjectList.vue?vue&type=script&lang=js&"
import style0 from "./LawSubjectList.vue?vue&type=style&index=0&id=6d3e3748&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports